<template>
  <div class="ql-editor">
    <Spin :spinning="loading">
      <Empty v-if="!content" />
      <div v-html="content"></div>
    </Spin>
  </div>
</template>
<script setup lang="ts">
/** 回显 Quill 的富文本内容 */
import { computed } from 'vue'
import { Spin, Empty } from 'ant-design-vue'

const props = defineProps<{
  content?: string
}>()

const loading = computed(() => {
  if (props.content === undefined) {
    return true
  }
  return false
})
</script>
<style lang="less" scoped></style>
